import Vue from "vue";

Vue.mixin({
    methods: {
        attachKeapInfo(outputObj, additionalInfo, listFields, dataObj) {
            if (additionalInfo && additionalInfo.add_to_keap) {
                const listKeapFields = listFields
                    .filter((field) => field.keapCustomField)
                    .map((field) => ({
                        id: field.keapCustomField,
                        content: dataObj[field.model],
                    }))
                    .filter((field) => field.content);
                const listCustomFields = listKeapFields.filter(
                    (field) => typeof field.id === "number"
                );
                const listStringKeysFields = listKeapFields.filter(
                    (field) => typeof field.id === "string"
                );
                // Get social media fields
                let fieldTypeKey = "Social Media (";
                const listSocialMediaFields = listStringKeysFields
                    .filter((field) => field.id.indexOf(fieldTypeKey) === 0)
                    .map((field) => {
                        return {
                            name: field.content,
                            type: field.id.substring(
                                fieldTypeKey.length,
                                field.id.length - 1
                            ),
                        };
                    });
                // Get phone fields
                fieldTypeKey = "Phone (";
                const listPhoneFields = listStringKeysFields
                    .filter((field) => field.id.indexOf(fieldTypeKey) === 0)
                    .map((field, index) => {
                        return {
                            number: field.content,
                            type: field.id.substring(
                                fieldTypeKey.length,
                                field.id.length - 1
                            ),
                            field: "PHONE" + (index + 1),
                        };
                    });
                // Get fax fields
                fieldTypeKey = "Fax (";
                const listFaxFields = listStringKeysFields
                    .filter((field) => field.id.indexOf(fieldTypeKey) === 0)
                    .map((field, index) => {
                        return {
                            number: field.content,
                            type: field.id.substring(
                                fieldTypeKey.length,
                                field.id.length - 1
                            ),
                            field: "FAX" + (index + 1),
                        };
                    });
                outputObj["keap_custom_data"] = {
                    custom_fields: listCustomFields,
                    social_accounts: listSocialMediaFields,
                    phone_numbers: listPhoneFields,
                    fax_numbers: listFaxFields,
                };
            }
        },
    }
});


// WEBPACK FOOTER //
// ./src/mixins/keap-handling.js